export const restaurantOrdersEs = {
  title: {
    deliveryTakeaway: 'Delivery y para llevar',
    deliveryTakeawayConfiguration: 'Configuración de Delivery y para llevar',
    orderHistoryDocument: 'Historial de pedidos · Delivery y para llevar',
    orderHubEyebrow: 'Centro de pedidos',
    operationalManagement: 'Gestión operativa',
  },
  workspace: {
    selectBranchToManage: 'Selecciona una sucursal para gestionar {{title}}.',
    newOrder: 'Nuevo pedido',
    searchOrderPlaceholder: 'Buscar pedido…',
    orderTypeAriaLabel: 'Tipo de pedido',
    channelDelivery: 'DELIVERY',
    channelTakeaway: 'PARA LLEVAR',
    processedAriaLabel: 'Procesados',
    processedTitle: 'Pedidos procesados',
    processed: 'Procesados',
    refreshOrdersLabel: 'Actualizar pedidos',
    refreshOrdersTitle: 'Actualizar pedidos',
    attentionLabel: 'Por gestionar',
    unsupportedStatesAlert:
      '{{count}} pedidos tienen estados de la API incompatibles con el nuevo flujo de trabajo.',
    unsupportedStatesHint:
      'Aparecen en el calendario, pero no se pueden asignar automáticamente a las columnas del tablero. Comprueba los estados devueltos por el backend.',
  },
  board: {
    elapsedNow: 'Ahora',
    elapsedMinutesAgo: 'hace {{minutes}} min',
    elapsedHoursAgo: 'hace {{hours}} h',
    elapsedDaysAgo: 'hace {{days}} d',
    productsCount: '{{count}} artículos',
    paymentMethodTitle: 'Método de pago',
    orderCardAriaLabel:
      'Pedido {{id}} · {{name}}. Pulsa Intro para abrir, espacio para arrastrar.',
    columnSubtitles: {
      inArrivo: 'Nuevos pedidos por revisar',
      accettato: 'Pedidos confirmados',
      inLavorazione: 'Pedidos en preparación',
      pronto: 'Listo para recoger o enviar',
    },
    archiveReadyTitle: 'Archivar pedidos listos',
    archiveReadyAriaLabel: 'Archivar pedidos listos',
    dropHere: 'Suelta aquí',
    noOrders: 'Sin pedidos',
    orderUpdatedRetry:
      'Pedido actualizado. Inténtalo de nuevo con el estado actual.',
  },
  detail: {
    orderTitle: 'Pedido #{{id}} · {{channel}}',
    orderDetail: 'Detalle del pedido',
    refreshOrderLabel: 'Actualizar pedido',
    refreshOrderTitle: 'Actualizar pedido',
    orderActivityLabel: 'Actividad del pedido',
    orderActivityTitle: 'Actividad del pedido',
    loadError: 'No se pudo cargar el pedido.',
    scheduledDelivery: 'Entrega programada',
    scheduledPickup: 'Recogida programada',
    deliveryAddress: 'Dirección de entrega',
    pickupPoint: 'Punto de recogida',
    emptyAddress: '—',
    outcome: 'Resultado:',
    orderDishes: 'Artículos del pedido',
    editDishes: 'Editar artículos',
    allergens: 'Alérgenos:',
    perDish: '{{price}} / artículo',
    deliveryFeeLine: 'Delivery {{fee}}',
    orderUpdatedToast: 'Pedido actualizado.',
    operationFailed:
      'La operación ha fallado. Recarga los detalles e inténtalo de nuevo.',
    moveOrder: 'Mover pedido',
    orderNumber: 'Pedido #{{id}}',
    chooseStatus: 'Elegir estado',
    reopenToStatus: 'Volver al estado',
    chooseOperationalStatus: 'Elige un estado operativo',
    orderOutcome: 'Resultado del pedido',
    chooseReason: 'Elige un motivo',
    confirmMove: 'Confirmar el cambio',
    notifyCustomer: 'Notificar al cliente',
    doNotNotify: 'No notificar',
    unpaidTitle: 'Pedido aún sin pagar',
    unpaidBody:
      'Este pedido aún no está pagado. ¿Seguro que quieres pasarlo a en preparación?',
    unpaidHint:
      'El pago seguirá pendiente. Esta acción no realiza ningún cargo al cliente.',
    noActivity: 'No hay actividad registrada.',
    depositNotAuthorizedApi:
      'El depósito aún no está autorizado. Espera la autorización de pago del cliente.',
  },
  create: {
    title: 'Nuevo pedido',
    description:
      'Elige el servicio, añade productos y completa los datos del cliente.',
    loadServicesError: 'No se pudieron cargar los servicios.',
    loadingServices: 'Cargando servicios…',
    publishServiceHint:
      'Publica un servicio de para llevar o delivery en Configuración.',
    whichService: '¿Qué servicio quieres usar?',
    loadingMenuSlots: 'Cargando menú y franjas horarias…',
    loadMenuSlotsError: 'No se pudieron cargar el menú y las franjas horarias.',
    noModeAvailable: 'No hay ninguna modalidad disponible para este servicio.',
    operationFailed: 'La operación ha fallado. Inténtalo de nuevo.',
    addAtLeastOneProduct: 'Añade al menos un producto.',
    productUnavailable: 'Un producto ya no está disponible.',
    checkProducts: 'Revisa los productos.',
    enterCustomerName: 'Introduce el nombre y los apellidos del cliente.',
    enterValidPhone:
      'Introduce un número de teléfono válido con prefijo internacional.',
    fixOrClearEmail: 'Corrige el correo electrónico o deja el campo vacío.',
    chooseDayAndSlot: 'Elige un día y una hora disponibles.',
    chooseActiveDriver:
      'Elige un repartidor activo o deja «Asignar más tarde».',
    enterFullDeliveryAddress:
      'Introduce la dirección de entrega completa, incluido el número.',
    reloadService: 'Recarga el servicio.',
    quoteExpired:
      'El presupuesto ha caducado. Revisa los detalles y actualiza el resumen.',
    stepsAriaLabel: 'Pasos del nuevo pedido',
    steps: {
      service: 'Servicio',
      products: 'Productos',
      customer: 'Cliente',
      confirm: 'Confirmar',
    },
    footerProductsTotal: '{{count}} artículos · {{total}}',
    footerTotalOrder: 'Total del pedido',
    footerDeliveryInSummary: 'Gastos de envío en el resumen',
    wait: 'Espera un momento…',
    stepActions: {
      chooseProducts: 'Elegir productos',
      customerDetails: 'Datos del cliente',
      reviewOrder: 'Revisar pedido',
      createOrder: 'Crear pedido',
    },
    channelSectionTitle: '¿Cómo recibirá el cliente el pedido?',
    channelSectionHint:
      'Para llevar: lo recoge él mismo. Delivery: se lo llevamos.',
    channelTakeaway: 'Para llevar',
    channelDelivery: 'Delivery',
    changeChannelConfirm:
      '¿Cambiar de modalidad y vaciar los productos ya añadidos?',
    whatToOrder: '¿Qué le gustaría pedir?',
    menuCategoriesAriaLabel: 'Categorías del menú',
    allMenu: 'Menú completo',
    otherProducts: 'Otros productos',
    searchProduct: 'Buscar un producto',
    searchProductPlaceholder: 'Nombre del producto…',
    fromMenu: 'Del menú',
    addProductAria: 'Añadir {{name}}',
    compose: 'Configurar',
    add: 'Añadir',
    cartAriaLabel: 'Artículos del pedido',
    yourOrder: 'Tu pedido',
    chooseProductToStart: 'Elige un producto del menú para empezar.',
    noExtraOptions: 'Sin opciones adicionales',
    decreaseQtyAria: 'Reducir cantidad',
    decreaseQtyForAria: 'Reducir la cantidad de {{name}}',
    quantityForAria: 'Cantidad de {{name}}',
    increaseQtyForAria: 'Aumentar la cantidad de {{name}}',
    anotherConfiguration: 'Otra configuración',
    removeConfigurationAria: 'Eliminar configuración {{index}}',
    subtotal: 'Subtotal',
    customerAndFulfillment: 'Cliente y {{fulfillment}}',
    fulfillmentDelivery: 'entrega',
    fulfillmentPickup: 'recogida',
    customerRequiredHint:
      'El nombre, los apellidos y el teléfono son obligatorios.',
    emailOptional: 'Correo electrónico (opcional)',
    emailPlaceholder: 'cliente@ejemplo.com',
    fullAddress: 'Dirección completa',
    fullAddressPlaceholder: 'Calle, número, código postal y ciudad',
    driver: 'Repartidor',
    assignLater: 'Asignar más tarde',
    driversLoadError:
      'No se pudieron cargar los repartidores. Puedes asignar uno más tarde.',
    deliveryTime: 'Hora de entrega',
    pickupTime: 'Hora de recogida',
    bookUntil: 'Puedes reservar hasta el {{date}}.',
    notesOptional: 'Notas (opcional)',
    notesPlaceholder: 'Portero automático, instrucciones para la cocina…',
    reviewAndCreate: 'Revisar y crear el pedido',
    driverLine: 'Repartidor:',
    toAssign: 'Por asignar',
    afterCreateHint:
      'Tras la creación podrás gestionar el pedido y solicitar un depósito.',
    productConfigHint:
      'Elige los ingredientes de esta configuración. Para ingredientes distintos, añade otra configuración.',
    requiredSuffix: ' · obligatorio',
    quantity: 'Cantidad',
    reduceQuantityAria: 'Reducir cantidad',
    addToOrder: 'Añadir al pedido',
    saveChanges: 'Guardar cambios',
    selection: {
      quantityRange: 'Elige una cantidad entre 1 y 99.',
      productUnavailableForService:
        'Producto no disponible para este servicio.',
      optionUnavailable:
        'Una de las opciones seleccionadas no está disponible.',
    },
    cartErrors: {
      invalidLine: 'Línea de pedido no válida.',
      maxSameConfiguration:
        'Puedes añadir como máximo 99 unidades de la misma configuración.',
      maxConfigurations: 'Máximo 100 configuraciones por pedido.',
      configurationsRange: 'Añade entre 1 y 100 configuraciones.',
      invalidAmountOrPercentage: 'Importe o porcentaje no válido.',
      checkOrderProducts: 'Revisa los productos del pedido.',
      minimumOrder: 'Pedido mínimo: {{amount}} €.',
      invalidDeliveryFee: 'Gastos de envío no válidos. Recarga el servicio.',
    },
  },
  history: {
    selectBranch: 'Selecciona una sucursal para ver los pedidos.',
    subtitleDefault: 'Delivery y para llevar',
    searchTitle: 'Buscar en el historial',
    searchHint:
      'Elige un periodo o busca un pedido. Los resultados se actualizan automáticamente.',
    searchPlaceholder: 'Número de pedido, cliente, producto o contacto…',
    moreFilters: 'Más filtros',
    invalidDateRange: 'El intervalo de fechas no es válido.',
    exporting: 'Exportando…',
    exportCsv: 'Exportar CSV',
    exportFailed:
      'La exportación ha fallado. No se ha descargado ningún archivo parcial. Inténtalo de nuevo.',
    driversListUnavailable: 'Lista de repartidores no disponible.',
    searchUnavailable:
      'Búsqueda no disponible. Los filtros no han devuelto un resultado verificado.',
    searching: 'Buscando pedidos y resúmenes…',
    exactMatch: 'Coincidencia exacta',
    containsMatch: 'Búsqueda por texto contenido',
    exactMatchHint: 'No se incluyen los nombres más largos.',
    ordersFound: 'Pedidos encontrados',
    ordersFoundHint: 'Según el periodo y los filtros seleccionados',
    completedValue: 'Valor de los pedidos completados',
    completedValueHint:
      '{{count}} pedidos completados · importe total, aunque aún no estén pagados',
    stillUnpaid: 'Aún sin pagar',
    noUnpaidInResults: 'No hay pedidos sin pagar en los resultados',
    unpaidInResults: '{{count}} pedidos sin pagar en los resultados',
    ordersByDriver: 'Pedidos por repartidor',
    ordersByDriverHint: 'Responsable actual, incluidos los pedidos archivados.',
    driverSummary: '{{completed}} completados · {{unpaid}} por cobrar',
    orderList: 'Lista de pedidos',
    orderListHint: 'Usa «Detalles» para abrir un pedido.',
    resultsPage: '{{total}} resultados · Página {{page}} de {{pages}}',
    loadingPage: 'Cargando página…',
    noOrdersForFilters: 'No hay pedidos con estos filtros',
    table: {
      order: 'Pedido',
      dateTime: 'Fecha y hora',
      channel: 'Canal',
      orderStatus: 'Estado del pedido',
      payment: 'Pago',
      driver: 'Repartidor',
      total: 'Total',
      notAssigned: 'Sin asignar',
      openOrderAria: 'Abrir pedido {{id}}',
    },
    modalProcessed: 'Pedidos procesados',
    modalHistory: 'Historial de pedidos',
    filters: {
      paid: 'Pagado',
      unpaid: 'Sin pagar',
      allMethods: 'Todos los métodos',
      allDrivers: 'Todos',
      unassigned: 'Sin asignar',
      deliveryAndTakeaway: 'Delivery y para llevar',
      allStatuses: 'Todos',
      afterProcessed: 'Estado tras procesar',
      sortBy: 'Ordenar por',
      sortRecent: 'Más recientes',
      sortOldest: 'Más antiguos',
      sortTotalHigh: 'Mayor total',
      unassignedOnly: 'Sin asignar',
      driverFilter: 'Repartidor: {{name}}',
    },
    export: {
      incompleteResults: 'Resultados incompletos. Inténtalo de nuevo.',
      filename: 'historial-pedidos.csv',
      headers: {
        order: 'Pedido',
        customer: 'Cliente',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        schedule: 'Entrega / recogida',
        channel: 'Canal',
        products: 'Productos',
        driver: 'Repartidor',
        totalEur: 'Total EUR',
        orderStatus: 'Estado del pedido',
        paymentStatus: 'Estado del pago',
        paymentMethod: 'Método de pago',
      },
      productLine: '{{quantity}} × {{name}}',
    },
    pagination: {
      perPage: 'Por página',
      ordersCount: '{{count}} pedidos',
      previous: 'Anterior',
      next: 'Siguiente',
    },
    topCustomersHint:
      'Los 10 primeros por valor de pedidos completados, entre todos los resultados filtrados.',
    noCompletedInResults: 'No hay pedidos completados en los resultados.',
  },
  drivers: {
    manageHint:
      'Gestiona los colaboradores que se pueden asignar a las entregas.',
    addDriver: 'Añadir repartidor',
    loadError: 'No se pudieron cargar los repartidores.',
    empty: 'No hay repartidores configurados',
    columns: {
      driver: 'Repartidor',
      phone: 'Teléfono',
      status: 'Estado',
      actions: 'Acciones',
    },
    active: 'Activo',
    inactive: 'Inactivo',
    ordersAndMap: 'Pedidos y mapa',
    deleteTitle: 'Eliminar repartidor',
    deleteConfirm:
      '¿Eliminar a {{name}}? Se revocará su acceso y los pedidos abiertos quedarán sin asignar. Se conservará el historial.',
    deleteAction: 'Eliminar repartidor',
    deletedToast: 'Repartidor eliminado.',
    deleteError: 'No se pudo eliminar al repartidor.',
    editTitle: 'Editar repartidor',
    newTitle: 'Nuevo repartidor',
    username: 'Nombre de usuario',
    passwordNew: 'Contraseña · al menos 4 caracteres',
    passwordKeep: 'Nueva contraseña (déjala en blanco para mantener la actual)',
    passwordMinError: 'Introduce al menos 4 caracteres.',
    accessHint:
      'El repartidor inicia sesión desde el botón del scooter en el menú público. Comparte las credenciales directamente con él. La contraseña no se volverá a mostrar.',
    activeToggleAria: 'Repartidor activo',
    activeToggle: 'Repartidor activo',
    savedToast: 'Repartidor guardado.',
    saveError: 'No se pudo guardar al repartidor.',
    createdByDriver: 'Creado por el repartidor:',
    assignedLabel: 'Repartidor asignado',
    notAssigned: 'Sin asignar',
    deactivatedSuffix: ' · desactivado',
    deletedSuffix: ' · eliminado',
    driverLine: 'Repartidor:',
    assignSuccess: 'Repartidor asignado',
    unassignSuccess: 'Asignación eliminada',
    assignError: 'No se pudo asignar al repartidor.',
    discountCard: 'Tarjeta de descuento',
    giftCard: 'Tarjeta regalo:',
    giftCardCaptured: 'Cobrada',
    giftCardReleased: 'Liberada',
    giftCardReserved: 'Reservada',
    amountDue: 'Por cobrar:',
  },
  config: {
    title: 'Configuración de Delivery y para llevar',
    sectionAriaLabel: 'Servicios de para llevar y delivery',
    introTitle: 'Gestiona cómo recibes los pedidos',
    introBody:
      'Usa Editar para configurar el menú, los días, los horarios y los pagos de cada servicio. Comparte el enlace o el código QR para que los clientes puedan pedir.',
    searchPlaceholder: 'Buscar un servicio…',
    newService: 'Nuevo servicio',
    templateLoadError: 'No se pudieron cargar los datos iniciales.',
    servicesLoadError: 'No se pudieron cargar los servicios.',
    emptySearch: 'Ningún servicio coincide con la búsqueda',
    empty: 'No hay servicios configurados',
    columns: {
      service: 'Servicio',
      orderType: 'Tipo de pedido',
      visibility: 'Visibilidad',
      manageShare: 'Gestionar y compartir',
    },
    preparationMinutes: 'Preparación {{minutes}} min',
    advanceDays: 'Pedidos con hasta {{days}} días de antelación',
    deliveryPausedSuffix: ' · en pausa',
    visibleToCustomers: 'Visible para los clientes',
    draftNotVisible: 'Borrador · no visible',
    openPage: 'Abrir página',
    servicesPerPage: 'Servicios por página',
    range: '{{start}}–{{end}} de {{total}}',
    previous: 'Anterior',
    next: 'Siguiente',
    linkCopied: 'Enlace copiado.',
    copyManually: 'Copia manualmente el enlace que se muestra.',
    removedToast: 'Servicio eliminado. Los pedidos existentes se conservan.',
    removeError: 'No se pudo eliminar el servicio.',
    shareModalTitle: 'Enlace para clientes · {{name}}',
    published: 'Publicado',
    draftPublishHint: 'Borrador · publica el servicio para recibir pedidos',
    publicLinkLabel: 'Enlace público de delivery / para llevar',
    shareHint:
      'El cliente elegirá entre los canales habilitados y las franjas disponibles de este servicio.',
    removeTitle: 'Eliminar servicio',
    removeConfirm:
      '¿Eliminar «{{name}}»? El servicio dejará de aceptar nuevos pedidos. Los pedidos existentes y el historial se conservarán.',
    removeAction: 'Eliminar servicio',
    editor: {
      editTitle: 'Editar servicio',
      newTitle: 'Nuevo servicio',
      stepService: '1 · Servicio',
      stepProducts: '2 · Productos',
      stepSchedulePayments: '3 · Horarios y pagos',
      savePublish: 'Guardar y publicar',
      saveDraft: 'Guardar borrador',
      serviceName: 'Nombre del servicio',
      serviceNameHint:
        'Este nombre es el título de la página pública que los clientes abren desde el enlace o el código QR para pedir delivery o para llevar.',
      chooseMenu: 'Elegir menú',
      menusLoadError: 'No se pudieron cargar los menús.',
      enableTakeaway: 'Activar para llevar',
      enableDelivery: 'Activar delivery',
      restaurantPhoto: 'Foto del restaurante (opcional)',
      restaurantPhotoHint:
        'Haz clic para elegir y subir una foto desde tu dispositivo.',
      removeRestaurantPhoto: 'Eliminar foto del restaurante',
      photoLoading: 'Subiendo foto…',
      photoUploadedToast: 'Foto subida. Guarda el servicio para confirmar.',
      photoUploadError: 'No se pudo subir la foto del restaurante.',
      photoNoUrl:
        'La subida no devolvió la URL de la imagen. Inténtalo de nuevo.',
      productsIntro:
        'Elige los productos disponibles y los precios por canal. Los ingredientes y las variantes proceden del menú compartido. Para confirmar un precio modificado, pulsa Guardar junto al campo.',
      searchProductsPlaceholder: 'Buscar un producto o sección…',
      productsLoadError: 'No se pudieron cargar los productos.',
      productsLoading: 'Cargando productos…',
      noProducts: 'No se han encontrado productos',
      chooseMenuFirst: 'Elige primero un menú',
      sectionControlsHint:
        '{{count}} productos · los controles se aplican a toda la sección, incluso durante la búsqueda.',
      partial: ' · Parcial',
      activeCount: '{{enabled}}/{{total}} activos',
      sectionToggleAria: '{{channel}}: toda la sección {{name}}',
      product: 'Producto',
      takeaway: 'Para llevar',
      delivery: 'Delivery',
      options: 'Ingredientes y opciones',
      syncedWithMenu: ' · Sincronizado con el menú',
      priceAria: 'Precio de {{channel}} de {{name}}',
      savePriceAria: 'Guardar precio de {{channel}} de {{name}}',
      invalidPrice: 'Introduce un precio válido mayor o igual que cero.',
      updateFailed: 'La actualización ha fallado',
      productsUpdatedPartial:
        '{{completed}} de {{total}} productos actualizados. No actualizados: {{failures}}',
      priceUpdatedToast: 'Precio actualizado.',
      productsUpdatedToast: '{{count}} productos actualizados.',
      menuLoadFailed:
        'No se pudo cargar el menú. No se ha aplicado ningún cambio.',
      recipeSyncHint:
        'Los interruptores de los productos sincronizados actualizan la receta de inmediato, también en el menú y en otros servicios que la usen. Los precios guardados aquí también actualizan el menú y otros servicios. Cancelar no deshace estos cambios. Para los productos no sincronizados, guarda el servicio para confirmar. Edita los ingredientes en el menú.',
      prepMinutes: 'Preparación media (min)',
      slotMinutes: 'Duración de la franja de entrega/recogida (minutos)',
      slotHint:
        'Con 15 minutos, el cliente puede elegir de 19:00 a 19:15 y después de 19:15 a 19:30. El tiempo de preparación se establece por separado.',
      advanceDaysLabel: 'Antelación máxima del pedido (días)',
      advanceDaysHint:
        'Con 7 días, el cliente puede pedir para una fecha dentro de los próximos 7 días, en el horario de apertura configurado.',
      minimumOrder: 'Pedido mínimo (€)',
      freeDeliveryFrom: 'Envío gratis a partir de (€)',
      deliveryRadius: 'Radio de entrega (km)',
      weeklyCalendar: 'Calendario semanal · horario de recepción de pedidos',
      from: 'Desde',
      slotStartAria: 'Inicio de la franja {{index}}',
      slotEndAria: 'Fin de la franja {{index}}',
      removeSlotAria: 'Eliminar franja',
      addSlot: 'Añadir franja',
      paymentMethods: 'Métodos de pago aceptados',
      cardOnly: 'Solo tarjeta',
      cashAndCard: 'Efectivo y tarjeta',
      stripeChecking: 'Comprobando Stripe…',
      stripeRequired:
        'Para activar los pagos con tarjeta, completa la configuración de Stripe y el alta de la sucursal.',
      cardStripeError:
        'Para activar los pagos con tarjeta, completa la configuración de Stripe y el alta de la sucursal.',
      publication: 'Publicación',
      pauseDelivery: 'Pausar el delivery temporalmente',
      pauseDeliveryHint:
        'La sección de delivery de este servicio se puede desactivar temporalmente. Vuelve a activarla desmarcando la casilla y guardando el servicio. Para llevar sigue disponible si está activado.',
      publishService: 'Publicar servicio',
      savedPublishedToast: 'Servicio guardado como publicado.',
      savedDraftToast: 'Borrador guardado.',
      saveError: 'No se pudo guardar el servicio.',
      pendingPrices:
        'Guarda los precios modificados con el botón junto a cada campo antes de continuar.',
      distanceBandsUnsupported:
        'Hay que actualizar la API vinculada para poder guardar los tramos de distancia.',
      distanceBandsNotReturned:
        'El servidor no devolvió los tramos guardados. La configuración sigue abierta: recarga el servicio antes de volver a intentarlo.',
      productDetailsTitle: 'Detalles del producto · {{name}}',
      productDetails: 'Detalles del producto',
      closeDetails: 'Cerrar detalles',
      ingredients: 'Ingredientes:',
      allergens: 'Alérgenos:',
      notSpecified: 'No especificado',
      noOptionsForChannel: 'No hay opciones para este canal',
      group: 'Grupo',
      ingredient: 'Ingrediente',
      supplement: 'Suplemento',
      minMax: 'Mín. {{min}}{{max}}',
      maxSuffix: ' · Máx. {{max}}',
      weekdays: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo',
      },
    },
    validation: {
      serviceName: 'Introduce un nombre de servicio (máximo 120 caracteres).',
      chooseMenu: 'Elige el menú del servicio.',
      enableChannel: 'Activa al menos delivery o para llevar.',
      integerRange:
        '{{label}}: introduce un número entero entre {{min}} y {{max}}.',
      preparation: 'Preparación',
      slotDuration: 'Duración de la franja',
      bookableDays: 'Días reservables',
      amounts: 'Introduce importes positivos con un máximo de dos decimales.',
      deliveryRadius:
        'El radio de entrega debe ser mayor que 0 y de 100 km como máximo.',
      timezone: 'Introduce una zona horaria válida.',
      location:
        'Completa la dirección y las coordenadas en la configuración de la sucursal.',
      geocoding:
        'El servicio de verificación de la zona de entrega no está configurado.',
      openingHours: 'Introduce entre 1 y 28 franjas de apertura.',
      openingHoursOrder:
        'Revisa las franjas de apertura: la hora de fin debe ser posterior a la de inicio.',
      enableProduct: 'Activa al menos un producto para un canal activo.',
      productPrices: 'Revisa los precios de los productos.',
    },
  },
  modals: {
    archive: {
      title: 'Archivar pedidos listos',
      intro:
        'Los pedidos seleccionados se archivarán: delivery como Entregado, para llevar como Recogido. El método de pago no cambia.',
      markAllPaid: 'Marcar todos los seleccionados como pagados',
      deliverySection: 'Delivery · Entregado',
      takeawaySection: 'Para llevar · Recogido',
      paid: 'Pagado',
      noReadyOrders: 'No hay pedidos listos.',
      archiving: 'Archivando…',
      archiveCount: 'Archivar {{count}} pedidos',
      archiveError:
        'El archivado ha fallado. Recarga los pedidos e inténtalo de nuevo.',
    },
    processed: {
      title: 'Pedidos procesados · {{date}}',
      searchPlaceholder: 'Buscar cliente, teléfono o número de pedido…',
      orderOutcome: 'Resultado del pedido',
      allReasons: 'Todos los motivos',
      empty: 'No hay pedidos archivados',
      columns: {
        order: 'Pedido',
        channel: 'Canal',
        schedule: 'Hora de entrega / recogida',
        total: 'Total',
        driver: 'Repartidor',
        outcome: 'Resultado',
        payment: 'Pago',
      },
      perPage: 'Por página',
      ordersCount: '{{count}} pedidos',
      previous: 'Anterior',
      next: 'Siguiente',
    },
    payment: {
      cardTitle: 'Pago con tarjeta',
      loadingStripe: 'Cargando el formulario de Stripe…',
      loadError:
        'No se pudo cargar el pago. El pedido está guardado y a la espera de pago.',
      retryPayment: 'Reintentar el pago',
      payAmount: 'Pagar {{amount}}',
      confirmedOnPayment: 'El pedido se confirmará cuando se reciba el pago.',
      paymentFailed: 'El pago ha fallado. Inténtalo de nuevo.',
      paymentIncomplete: 'El pago no se ha completado. Inténtalo de nuevo.',
      verifyFailed:
        'No se pudo verificar el pago. Vuelve a intentarlo con el mismo pedido.',
    },
    itemsEditor: {
      title: 'Editar artículos',
      titleWithOrder: 'Editar artículos · Pedido #{{id}}',
      loadError:
        'La edición del pedido requiere las nuevas API del backend. No se ha modificado ningún dato.',
      loadingMenu: 'Cargando menú…',
      notEditable: 'Este pedido no se puede editar en su estado actual.',
      saveError:
        'No se pudo guardar. Recarga el pedido si otro operador lo ha modificado.',
      menuChannel: 'Menú · {{channel}}',
      searchPlaceholder: 'Buscar un plato o sección…',
      orderItems: 'Artículos del pedido · {{count}}',
      removeDishAria: 'Eliminar plato',
      quantity: 'Cantidad',
      decreaseQtyAria: 'Reducir cantidad',
      optionIssue:
        'Comprueba la disponibilidad y el mínimo/máximo de ingredientes seleccionados.',
      addAtLeastOne:
        'Añade al menos un artículo. Para cancelar el pedido, usa la acción específica.',
      verifiedTotal: 'Nuevo total verificado',
      recalcHint:
        'El servidor recalcula los precios y los suplementos antes de guardar. Los cambios son locales hasta pulsar «Guardar cambios».',
      verifyTotal: 'Verificar nuevo total',
      saveChanges: 'Guardar cambios',
      unsavedConfirm: '¿Salir sin guardar los cambios de los artículos?',
      dishFallback: 'Artículo {{index}}',
    },
  },
  address: {
    suggestionsUnavailable:
      'Sugerencias no disponibles. Inténtalo de nuevo en breve para seleccionar la calle.',
    searching: 'Buscando direcciones…',
    suggestionsCount:
      '{{count}} direcciones sugeridas. Usa las flechas para elegir e Intro para confirmar.',
    notFound:
      'No se ha encontrado ninguna dirección. Revisa la calle y añade la ciudad.',
    verifyStreet: 'Verificando la calle y el número…',
    verifyFailed:
      'No hemos podido verificar la calle. Selecciona de nuevo una sugerencia para reintentarlo.',
    selectFromSuggestions:
      'Selecciona la calle de las sugerencias antes de continuar.',
    deliveryAddressSrOnly: 'Dirección de entrega',
    placeholder: 'Calle, número, ciudad y código postal',
    suggestedAddressesAria: 'Direcciones sugeridas',
    hint: 'Elige la calle de las sugerencias y completa el número.',
    streetNumber: 'Número *',
    streetNumberPlaceholder: 'p. ej., 10, 10/A',
    deliveryAddressPreview: 'Dirección de entrega:',
    yourAddress: 'Tu dirección',
    streetOnlyCity:
      'Selecciona una calle de las sugerencias, no solo una ciudad o zona.',
    fullAddressItaly:
      'Selecciona una dirección completa con calle y ciudad en Italia.',
    streetNumberRequired: 'Introduce el número de la calle para continuar.',
    streetNumberInvalid:
      'Introduce un número válido, p. ej., 10, 10/A o 10 bis.',
  },
  pricing: {
    ariaLabel: 'Coste de entrega',
    title: '¿Cómo calculas el coste de entrega?',
    intro:
      'Elige un único coste para todos o un precio total para cada tramo de distancia.',
    fixedCost: 'Coste fijo',
    distanceBands: 'Tramos de distancia',
    fixedFeeLabel: 'Coste por entrega (€)',
    fixedFeeHint:
      'El mismo importe para todas las direcciones dentro del radio de entrega.',
    bandsUnsupported:
      'Las API vinculadas aún no admiten guardar tramos. Puedes prepararlos aquí; el guardado estará disponible cuando se actualice el servicio.',
    bandsFlow:
      '1. Dirección dentro del radio de {{radius}} km → 2. Ruta por carretera → 3. Coste del tramo',
    bandsFlowHint:
      'El precio es el coste total de la entrega. Los kilómetros son la distancia por carretera, solo de ida, desde el local hasta el cliente. El último tramo cubre cualquier distancia mayor para las direcciones ya aceptadas.',
    allDistances: 'Todas las distancias',
    overKm: 'Más de {{km}} km',
    lastBandHint: 'Último tramo · sin límite de carretera adicional',
    bandUpTo: 'Tramo {{index}} · hasta (km)',
    bandFromZero: 'Desde 0 km, límite incluido.',
    bandAfterPrevious: 'Después de {{km}} km, límite incluido.',
    bandCost: 'Tramo {{index}} · coste total (€)',
    removeBandAria: 'Eliminar tramo {{index}}',
    addBand: 'Añadir tramo',
    bandChecksAria: 'Comprobaciones de tramos',
    simulateDistance: 'Simular distancia por carretera (km)',
    completeBandsForCost: 'Completa los tramos para ver el coste.',
    enterValidDistance: 'Introduce una distancia por carretera válida.',
    costAtDistance: 'Coste de entrega a {{km}} km: {{price}}',
    previewHint:
      'Vista previa del precio del tramo, antes de cualquier umbral de envío gratis.',
    bandErrors: {
      count: 'Introduce entre 1 y 30 tramos de distancia.',
      lastBand:
        'Tramo {{index}}: el último tramo cubre todas las distancias mayores.',
      distance:
        'Tramo {{index}}: introduce una distancia mayor que la anterior, hasta 1.000 km.',
      fee: 'Tramo {{index}}: introduce un coste de 0 a 999.999,99 € con un máximo de dos decimales.',
    },
  },
  payment: {
    sectionAria: 'Pago del pedido',
    paid: 'Pagado',
    markPaid: 'Marcar como pagado',
    paymentStatus: 'Estado del pago',
    toPay: 'Por pagar',
    saving: 'Guardando el pago…',
    specialStatusHint:
      'Los pagos de pedidos pendientes, reembolsados o cancelados requieren una revisión específica.',
    updateError:
      'No se pudo actualizar el pago. Recarga el pedido e inténtalo de nuevo.',
    branchUnavailable: 'Sucursal no disponible.',
    deposit: {
      ariaLabel: 'Solicitar depósito',
      title: 'Solicitar un depósito',
      intro:
        'Elige el porcentaje del total de {{total}}. El cliente recibirá un enlace para pagar.',
      received: 'Recibido:',
      remaining: 'Pendiente de pago:',
      defaultUnavailable: 'Enlaces de pago no disponibles: configura Stripe.',
      verifyBeforeNew:
        'El pago de este pedido requiere revisión antes de solicitar un nuevo depósito.',
      creating: 'Creando…',
      linkCreated: 'Enlace creado',
      createLinkFor: 'Crear enlace por {{amount}}',
      requested: 'Depósito solicitado: {{amount}}',
      customerLink: 'Enlace para el cliente',
      messageSent: 'Mensaje en envío / enviado',
      sending: 'Enviando…',
      sendWhatsApp: 'Enviar al cliente por WhatsApp',
      copied: 'Copiado',
      copyLink: 'Copiar enlace',
      copyFromField: 'Copia el enlace del campo de arriba.',
      whatsAppHint:
        'Usa el mensaje «Enlace de pago» configurado en el Centro de mensajes. Crear o enviar el enlace no marca el pedido como pagado.',
      requestMismatch:
        'La solicitud devuelta no coincide con el depósito elegido. Recarga el pedido.',
      requestUnavailable:
        'Solicitud no disponible. El servicio de la API debe admitir depósitos en los pedidos.',
      sendNotConfirmed: 'Envío no confirmado.',
      sendError:
        'No se pudo enviar el mensaje. Comprueba la configuración de WhatsApp para el mensaje «Enlace de pago».',
      invalidPaymentRequest: 'Solicitud de pago no válida.',
      invalidPaymentLink: 'Enlace de pago no válido.',
    },
  },
  labels: {
    inArrivo: 'Entrantes',
    accettato: 'Aceptado',
    archiviato: 'Procesado',
    accept: 'Aceptar pedido',
    archive: 'Marcar como procesado',
    reopen: 'Reabrir pedido',
    eliminato: 'Eliminado',
    nonConsegnato: 'No entregado',
    delivery: 'Delivery',
    takeaway: 'Para llevar',
    ricevuto: 'Recibido',
    presaInCarico: 'En gestión',
    confermato: 'En gestión',
    inAttesaDiPagamento: 'Pendiente de pago',
    inLavorazione: 'En preparación',
    pronto: 'Listo',
    ritirato: 'Recogido',
    inConsegna: 'En reparto',
    consegnato: 'Entregado',
    rifiutato: 'Rechazado',
    annullato: 'Cancelado',
    nonRitirato: 'No recogido',
    consegnaFallita: 'Entrega fallida',
    daPagare: 'Por pagar',
    inAttesa: 'Pendiente',
    pagato: 'Pagado',
    parzialmentePagato: 'Depósito recibido',
    unspecified: 'Por definir',
    fallito: 'Fallido',
    rimborsato: 'Reembolsado',
    cash: 'Efectivo',
    card: 'Tarjeta',
    takeCharge: 'Gestionar',
    reject: 'Rechazar pedido',
    prepare: 'Iniciar preparación',
    ready: 'Marcar como listo',
    assign: 'Asignar repartidor',
    dispatch: 'Salir a repartir',
    collect: 'Confirmar recogida',
    deliver: 'Confirmar entrega',
    fail: 'Notificar problema',
    cancel: 'Cancelar pedido',
    cashPaid: 'Registrar pago en efectivo',
    refund: 'Reembolsar a la tarjeta',
    cashRefund: 'Registrar reembolso en efectivo',
    notCollected: 'No recogido',
    active: 'Por gestionar',
    completed: 'Completados',
    issues: 'Cancelados / incidencias',
    scheduleAsap: 'Lo antes posible',
  },
};
